import { IAppState } from '@interfaces/api/IAppState';

export const selectedPrompt = (state: IAppState) => state.prompt;
